"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CardPriority = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CardPriority = function CardPriority(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.978 6.62l.277-.691H7.69l-.225.001c-.502.009-.845.047-1.103.143-.494.192-.836.596-.836 1.127 0 .442.206.762.801 1.13.636.385.763.512.763.744 0 .254-.25.543-.89.543-.223 0-.56-.03-.775-.083l-.103-.026-.075.207-.152.441.102.03.098.026c.224.049.602.084.884.084 1.095 0 1.748-.661 1.748-1.354 0-.425-.194-.748-.846-1.156l-.131-.082a2.794 2.794 0 01-.465-.351.385.385 0 01-.092-.267c0-.08.018-.17.07-.238.057-.082.16-.135.3-.179.124-.04.338-.047.659-.048h.556zm2.639-.691c.073 0 .1.041.089.094L9.363 9.388H8.56l.91-2.297c.09-.226.162-.402.196-.48l-.494.009h-.778l.277-.691h1.946z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6 2.4A1.6 1.6 0 000 4v8a1.6 1.6 0 001.6 1.6h12.8A1.6 1.6 0 0016 12V4a1.6 1.6 0 00-1.6-1.6H1.6zM4 8a4.001 4.001 0 118.002.001 4.001 4.001 0 01-8.002 0z",
    fill: "currentColor"
  }));
};

exports.CardPriority = CardPriority;
var _default = CardPriority;
exports.default = _default;